export const fetchJson = async <T>(
  url: string,
  backupUrls: string[] = [],
): Promise<T> => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Primary source failed');

    return await response.json();
  } catch (error) {
    if (backupUrls.length === 0) {
      throw error;
    }
    return fetchJson(backupUrls[0], backupUrls.slice(1));
  }
};
